// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes _15rxkih0 {
  0%,20%,50%,80%,to {
    top: 0;
  }
  40% {
    top: -6px;
  }
  60% {
    top: -3px;
  }
}
._15rxkih1 {
  width: 100%;
}
._15rxkih2 {
  width: 100%;
}
._15rxkih3 {
  width: 100%;
}
._15rxkih4 {
  height: 70px;
  width: 100%;
  max-width: 100%;
}
.calendar-tab {
  min-width: 98px;
  width: initial;
  position: relative;
}
.calendar-tab:hover > .calendar-tab-header {
  background-color: #af0937 !important;
  color: #fff !important;
}
.calendar-tab.calendar-tab-vip {
  background-color: var(--_18w76bw25);
}
.calendar-tab.calendar-tab-vip > .calendar-tab-header::before {
  content: " ";
  height: 68px;
  display: block;
  position: absolute;
  bottom: 13px;
  left: 0;
  right: 0;
  background-color: #606060;
  clip-path: polygon(50% 8%, 100% 0, 100% 100%, 0 100%, 0 0);
}
.calendar-tab.calendar-tab-vip:hover > .calendar-tab-header {
  color: #000 !important;
}
.calendar-tab:not(.calendar-tab-vip):hover > .calendar-tab-body {
  border-left: 1px solid #af0937;
  border-right: 1px solid #af0937;
}
._15rxkih5 {
  width: 30%;
}
._15rxkih6 {
  position: absolute;
  width: 100%;
  top: -56px;
}
._15rxkih7 {
  background: var(--_18w76bw25);
  border-radius: 6px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 39%);
  position: relative;
  animation: _15rxkih0 1.5s ease infinite;
}
._15rxkih7::after {
  content: " ";
  background-color: var(--_18w76bw25);
  width: 5px;
  height: 5px;
  position: absolute;
  left: 50%;
  bottom: -3.5px;
  transform: rotate(45deg) translate(-50%);
  box-shadow: 2px 2px 3px 0 rgb(0 0 0 / 20%);
}
._15rxkih8 {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}
._15rxkih9 {
  position: absolute;
  width: 100%;
  top: -38px;
  z-index: 100;
}
._15rxkiha {
  background: var(--_18w76bw2g);
  white-space: nowrap;
  display: grid;
  padding: 5px;
  grid-auto-flow: column;
  gap: 4px;
  align-items: center;
  justify-items: center;
  border-radius: 40px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 39%);
  position: relative;
  text-transform: uppercase;
  animation: _15rxkih0 1.5s ease infinite;
}
._15rxkiha::after {
  content: " ";
  background-color: var(--_18w76bw2g);
  width: 5px;
  height: 5px;
  position: absolute;
  left: 50%;
  bottom: -3.5px;
  transform: rotate(45deg) translate(-50%);
  box-shadow: 2px 2px 3px 0 rgb(0 0 0 / 20%);
}
._15rxkihb {
  display: inline-block;
}
._15rxkihc {
  display: grid;
  grid-auto-flow: column;
  gap: 4px;
  align-items: center;
  justify-items: center;
  text-transform: uppercase;
}
._15rxkihd {
  background: var(--_18w76bw2g);
  white-space: nowrap;
  height: auto;
  display: none;
  padding: 8px;
  grid-auto-flow: column;
  gap: 4px;
  align-items: center;
  justify-items: center;
  border-radius: 40px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 39%);
  position: relative;
  text-transform: uppercase;
  color: var(--_18w76bw25);
}
._15rxkihd::after {
  content: ">";
}
._15rxkihe {
  width: 30%;
}
._15rxkihf {
  width: full;
}
._15rxkihg {
  min-width: initial;
}
@media screen and (min-width: 768px) {
  ._15rxkih1 {
    width: 50%;
  }
  ._15rxkih2 {
    width: 58.33333%;
  }
  ._15rxkih3 {
    width: 56%;
  }
  ._15rxkih5 {
    width: 50%;
  }
  ._15rxkihe {
    width: 25%;
  }
  ._15rxkihg {
    max-width: 400px;
    min-width: 200px;
    margin: 0 auto;
  }
}
@media screen and (min-width: 1280px) {
  .calendar-tab {
    width: 8.33333%;
  }
}
@media screen and (max-width: 768px) {
  ._15rxkihd {
    display: grid;
  }
}
@media screen and (min-width: 480px) {
  ._15rxkihf {
    max-width: 300px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE;IACE,MAAM;EACR;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,0DAA0D;AAC5D;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,wCAAwC;EACxC,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;AACzC;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,wCAAwC;EACxC,0CAA0C;AAC5C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@keyframes _15rxkih0 {\n  0%,20%,50%,80%,to {\n    top: 0;\n  }\n  40% {\n    top: -6px;\n  }\n  60% {\n    top: -3px;\n  }\n}\n._15rxkih1 {\n  width: 100%;\n}\n._15rxkih2 {\n  width: 100%;\n}\n._15rxkih3 {\n  width: 100%;\n}\n._15rxkih4 {\n  height: 70px;\n  width: 100%;\n  max-width: 100%;\n}\n.calendar-tab {\n  min-width: 98px;\n  width: initial;\n  position: relative;\n}\n.calendar-tab:hover > .calendar-tab-header {\n  background-color: #af0937 !important;\n  color: #fff !important;\n}\n.calendar-tab.calendar-tab-vip {\n  background-color: var(--_18w76bw25);\n}\n.calendar-tab.calendar-tab-vip > .calendar-tab-header::before {\n  content: \" \";\n  height: 68px;\n  display: block;\n  position: absolute;\n  bottom: 13px;\n  left: 0;\n  right: 0;\n  background-color: #606060;\n  clip-path: polygon(50% 8%, 100% 0, 100% 100%, 0 100%, 0 0);\n}\n.calendar-tab.calendar-tab-vip:hover > .calendar-tab-header {\n  color: #000 !important;\n}\n.calendar-tab:not(.calendar-tab-vip):hover > .calendar-tab-body {\n  border-left: 1px solid #af0937;\n  border-right: 1px solid #af0937;\n}\n._15rxkih5 {\n  width: 30%;\n}\n._15rxkih6 {\n  position: absolute;\n  width: 100%;\n  top: -56px;\n}\n._15rxkih7 {\n  background: var(--_18w76bw25);\n  border-radius: 6px;\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 39%);\n  position: relative;\n  animation: _15rxkih0 1.5s ease infinite;\n}\n._15rxkih7::after {\n  content: \" \";\n  background-color: var(--_18w76bw25);\n  width: 5px;\n  height: 5px;\n  position: absolute;\n  left: 50%;\n  bottom: -3.5px;\n  transform: rotate(45deg) translate(-50%);\n  box-shadow: 2px 2px 3px 0 rgb(0 0 0 / 20%);\n}\n._15rxkih8 {\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n._15rxkih9 {\n  position: absolute;\n  width: 100%;\n  top: -38px;\n  z-index: 100;\n}\n._15rxkiha {\n  background: var(--_18w76bw2g);\n  white-space: nowrap;\n  display: grid;\n  padding: 5px;\n  grid-auto-flow: column;\n  gap: 4px;\n  align-items: center;\n  justify-items: center;\n  border-radius: 40px;\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 39%);\n  position: relative;\n  text-transform: uppercase;\n  animation: _15rxkih0 1.5s ease infinite;\n}\n._15rxkiha::after {\n  content: \" \";\n  background-color: var(--_18w76bw2g);\n  width: 5px;\n  height: 5px;\n  position: absolute;\n  left: 50%;\n  bottom: -3.5px;\n  transform: rotate(45deg) translate(-50%);\n  box-shadow: 2px 2px 3px 0 rgb(0 0 0 / 20%);\n}\n._15rxkihb {\n  display: inline-block;\n}\n._15rxkihc {\n  display: grid;\n  grid-auto-flow: column;\n  gap: 4px;\n  align-items: center;\n  justify-items: center;\n  text-transform: uppercase;\n}\n._15rxkihd {\n  background: var(--_18w76bw2g);\n  white-space: nowrap;\n  height: auto;\n  display: none;\n  padding: 8px;\n  grid-auto-flow: column;\n  gap: 4px;\n  align-items: center;\n  justify-items: center;\n  border-radius: 40px;\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 39%);\n  position: relative;\n  text-transform: uppercase;\n  color: var(--_18w76bw25);\n}\n._15rxkihd::after {\n  content: \">\";\n}\n._15rxkihe {\n  width: 30%;\n}\n._15rxkihf {\n  width: full;\n}\n._15rxkihg {\n  min-width: initial;\n}\n@media screen and (min-width: 768px) {\n  ._15rxkih1 {\n    width: 50%;\n  }\n  ._15rxkih2 {\n    width: 58.33333%;\n  }\n  ._15rxkih3 {\n    width: 56%;\n  }\n  ._15rxkih5 {\n    width: 50%;\n  }\n  ._15rxkihe {\n    width: 25%;\n  }\n  ._15rxkihg {\n    max-width: 400px;\n    min-width: 200px;\n    margin: 0 auto;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .calendar-tab {\n    width: 8.33333%;\n  }\n}\n@media screen and (max-width: 768px) {\n  ._15rxkihd {\n    display: grid;\n  }\n}\n@media screen and (min-width: 480px) {\n  ._15rxkihf {\n    max-width: 300px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
